import { render, staticRenderFns } from "./GridDestruccion.vue?vue&type=template&id=4fb90bb8&"
import script from "./GridDestruccion.vue?vue&type=script&lang=js&"
export * from "./GridDestruccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports